module.exports = __webpack_public_path__ + "assets/closer_2.66e169cf.svg";